import serviceRequest from "utils/request";

const baseUrl = "/api/role";

export const getRoleList = () => {
	return serviceRequest({
		url: `${baseUrl}/role-list`,
		method: "get",
	});
};

export const getRoleCodeList = () => {
	return serviceRequest({
		url: `${baseUrl}/role-code-list`,
		method: "get",
	});
};

export const getRoleSelectList = () => {
	return serviceRequest({
		url: `${baseUrl}/role-select-list`,
		method: "get",
	});
};

export const getHomepageList = () => {
	return serviceRequest({
		url: `${baseUrl}/homepage-list`,
		method: "get",
	});
};

export const editHomepage = (data) => {
	return serviceRequest({
		url: `${baseUrl}/edit-homepage`,
		method: "post",
		data,
	});
};
